import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button, createStyles } from '@material-ui/core';
import classnames from 'classnames';
import HtmlContent from '../../../HtmlContent';

const useStyles = makeStyles(theme => createStyles({
    question: {
        marginBottom: theme.spacing(1),
    },
    buttonStyle: {
        borderRadius: '100%',
        margin: theme.spacing(1),
        width: 'calc(33% - 16px)',
        minHeight: 150,
        fontWeight: 500,

        [theme.breakpoints.down('xs')]: {
            width: 'calc(50% - 16px)',
        },
    },
    unChecked: {
        background: theme.youwell.colors.secondaryBackground,
        '&:hover': {
            background: theme.youwell.colors.secondaryBackground,
        },
    },
    longText: {
        fontSize: '0.8rem',
    },
}));


const BubbleChoiceQuestions = ({
    question, response, handleResponseUpdate,
}) => {
    const classes = useStyles();

    const onBubbleClick = (answer, isChecked) => () => {
        const responses = (response?.choiceResponse || []).filter(d => d.id !== answer.id);
        handleResponseUpdate('choiceResponse', isChecked ? responses : [...responses, answer]);
    };

    const checkedResponses = response?.choiceResponse?.reduce((prev, curr) => (
        { ...prev, [curr.id]: curr.value }
    ), {}) || {};

    return (
        <div>
            <HtmlContent html={question.question} className={classes.question} />

            {question.answers?.map(item => (
                <Button
                    className={classnames(classes.buttonStyle, { [classes.unChecked]: !checkedResponses[item.id], [classes.longText]: item.value?.length > 45 })}
                    variant="contained"
                    color={checkedResponses[item.id] ? 'primary' : 'default'}
                    onClick={onBubbleClick(item, checkedResponses[item.id])}
                    key={item.id}
                >
                    {item.value}
                </Button>
            ))}
        </div>
    );
};

BubbleChoiceQuestions.propTypes = {
    question: PropTypes.object.isRequired,
    response: PropTypes.object,
    handleResponseUpdate: PropTypes.func.isRequired,
};

BubbleChoiceQuestions.defaultProps = {
    response: null,
};

export default BubbleChoiceQuestions;
